import { SERVICE_WORKER_EVENTS } from "constants/serviceWorker";
import HandlerRequestServiceWorker from "libs/service-worker/HandlerRequestServiceWorker";
import { sleep } from "./common";

export const handleRequest = async (event: FetchEvent) => {
  const requestHandler = new HandlerRequestServiceWorker();

  return await requestHandler.changeRequestResponse(event);
};

export const uninstallServiceWorker = async () => {
  const registrations = await navigator.serviceWorker.getRegistrations();
  if (registrations.length) {
    await new Promise((resolve, reject) => {
      navigator.serviceWorker.ready
        .then(async (registration) => {
          // send a message command to the service-worker to self-destroy, and the service-worker in turn reloads all controlled clients.
          registration?.active?.postMessage(SERVICE_WORKER_EVENTS.UNREGISTER);
          await sleep(1000);
          // with old service worker not listen message unregister -> must unregister
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};
